import { render } from "./ContentDetail.vue?vue&type=template&id=1dd401f4"
import script from "./ContentDetail.vue?vue&type=script&lang=js"
export * from "./ContentDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__